import { useCallback } from "react";

import { useAmplitude } from "../../../common/hooks/amplitude/useAmplitude";

import { TextFieldInputProps } from "./types";

export const useTextFieldWithCopy = ({
  onCopy,
  copyAmplitudeEvent,
  copyAmplitudePayload,
  value,
}: TextFieldInputProps) => {
  const { logAmplitudeEvent } = useAmplitude();

  const handleLinkCopy = useCallback(() => {
    if (copyAmplitudeEvent) {
      logAmplitudeEvent(copyAmplitudeEvent, copyAmplitudePayload);
    }
    if (value) {
      document.execCommand("copy");
      onCopy?.();
    }
  }, [copyAmplitudeEvent, value, logAmplitudeEvent, copyAmplitudePayload, onCopy]);

  const selectFullLink = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    return event && event.target && event.target.select();
  }, []);

  return {
    selectFullLink,
    handleLinkCopy,
  };
};
